/**
 * Split monetary intervals on common dash/minus characters (ASCII hyphen, Unicode dashes).
 * Plain `indexOf('-')` misses en-dash `–` / em-dash `—`, which breaks numeric sort and falls
 * back to lexical label order (e.g. "110" before "20").
 */
const PRICE_INTERVAL_SPLIT = /\s*[-–—−]\s*/;

export function priceIntervalLowBound(value: string): number | undefined {
  const trimmed = String(value).trim();
  const parts = trimmed.split(PRICE_INTERVAL_SPLIT).filter(Boolean);
  if (parts.length < 2) return undefined;
  const low = Number.parseFloat(parts[0].replace(',', '.'));
  return Number.isFinite(low) ? low : undefined;
}

export function sortPriceFilterOptions<T extends { label: string; value: string }>(
  options: T[],
): T[] {
  return options.toSorted((a, b) => {
    const la = priceIntervalLowBound(a.value);
    const lb = priceIntervalLowBound(b.value);
    if (la != null && lb != null) return la - lb;
    if (la != null) return -1;
    if (lb != null) return 1;
    return a.label.localeCompare(b.label);
  });
}
